import { captureMessage } from '@tink/core/src/sentry';
import { ajaxRetry as ajaxRetryImport } from '../ajaxRetry';
import { AnalyticsEventData, AnalyticsEventType, NewAnalyticsData } from '../../models/analytics';

import { base, createApiURL, ResponseObj } from './base';

type PostAnalyticsEventPayload = {
  data: AnalyticsEventData | NewAnalyticsData;
  analyticsEventType: AnalyticsEventType;
  ajaxRetry?: typeof ajaxRetryImport;
};

export type PostAnalyticsEvent = (
  payload: PostAnalyticsEventPayload
) => Promise<ResponseObj<Record<string, never>>>;

export const makeApiPayload = ({ analyticsEventType, data }: PostAnalyticsEventPayload) => {
  switch (analyticsEventType) {
    case AnalyticsEventType.VIEW_EVENT:
      return { type: AnalyticsEventType.VIEW_EVENT, viewEvent: data };
    case AnalyticsEventType.INTERACTION_EVENT:
      return { type: AnalyticsEventType.INTERACTION_EVENT, interactionEvent: data };
    case AnalyticsEventType.APPLICATION_EVENT:
      return { type: AnalyticsEventType.APPLICATION_EVENT, applicationEvent: data };
    default:
      return undefined;
  }
};

export const postAnalyticsMessage: PostAnalyticsEvent = ({
  analyticsEventType,
  data,
  ajaxRetry = ajaxRetryImport,
}) => {
  const payload = makeApiPayload({ analyticsEventType, data });

  if (!payload) {
    captureMessage(`${analyticsEventType} is invalid event type`);
  }

  return ajaxRetry<Record<string, never>>({
    data: JSON.stringify(payload),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL(`/link/v1/analytics`),
  });
};
